/* src/services/pairingKey.js — the short fingerprint of a device key that a QR code carries.
   Twin of the phone's services/pairingKey.ts (the same bytes in, the same string out) — see the
   note there: the phone registers this browser's key only when the key it finds in the session is
   the key this code named. */
import nacl from 'tweetnacl';
import util from 'tweetnacl-util';

export const FP_BYTES = 10;

/** hex of the first FP_BYTES of SHA-512 of the raw public key; '' for anything that is not one. */
export function keyFingerprint(pubB64) {
  try {
    if (typeof pubB64 !== 'string' || !pubB64) return '';
    const raw = util.decodeBase64(pubB64);
    if (raw.length !== nacl.box.publicKeyLength) return '';
    const h = nacl.hash(raw);
    let out = '';
    for (let i = 0; i < FP_BYTES; i++) out += h[i].toString(16).padStart(2, '0');
    return out;
  } catch { return ''; }
}

/** What the QR code says: the session, and the fingerprint of this browser's key. */
export function webLoginPayload(sessionId, publicKey) {
  return `web-login:${sessionId}:${keyFingerprint(publicKey)}`;
}
